<template>
  <div class="psy-index">
    <div class="img">
      <img @click="img" src="../../assets/sou.png" alt="" />
    </div>
    <van-tabs ref="tabs" v-model="active" title-active-color="#007AFF" sticky>
      <van-tab title="心灵视界">
        <div class="list">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="50"
          >
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
              <div
                class="one_list"
                v-for="(item, index) in xinlove"
                :key="index"
              >
                <div class="box">
                  <div class="box-left">
                    <div class="left">
                      <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        radius="6px"
                        :src="miXinGetImgUrl(item.titleUrl)"
                      />
                    </div>
                  </div>
                  <div class="box_right">
                    <div class="right">
                      <div class="right_top">
                        {{ item.title }}
                      </div>
                      <div class="right-botttom vottom">
                        <div style="display: flex; align-items: center">
                          <img src="../../assets/yan.png" alt="" />
                          <p>{{ item.pageview }}人观看</p>
                        </div>

                        <div class="button" @click="goHorizons(item.id)">
                          去学习
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-pull-refresh>
          </van-list>
        </div>
      </van-tab>
      <van-tab title="心灵之窗">
        <div class="list">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoadd"
            :offset="10"
          >
            <van-pull-refresh v-model="isLoading" @refresh="onRefreshs">
              <div
                class="one_list"
                v-for="(item, index) in chuangfast"
                :key="index"
              >
                <div class="box">
                  <div class="box-left">
                    <div class="left">
                      <van-image
                        width="100%"
                        height="100%"
                        fit="contain"
                        :src="miXinGetImgUrl(item.titleUrl)"
                      />
                    </div>
                  </div>
                  <div class="box_right">
                    <div class="right">
                      <div class="right_top">
                        {{ item.title }}
                      </div>
                      <div class="right-botttom vottom">
                        <div style="display: flex; align-items: center">
                          <img src="../../assets/yan.png" alt="" />
                          <p>{{ item.pageview }}人观看</p>
                        </div>

                        <div class="button" @click="goHorizon(item.id, index)">
                          去学习
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-pull-refresh>
          </van-list>
        </div>
      </van-tab>
      <van-tab title="心灵美文">
        <div class="list">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoaddd"
            :offset="50"
          >
            <van-pull-refresh v-model="isLoading" @refresh="onRefreshs">
              <div
                class="one_list"
                v-for="(item, index) in meimei"
                :key="index"
              >
                <div class="box">
                  <div class="box-left">
                    <div class="left">
                      <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        radius="6px"
                        :src="miXinGetImgUrl(item.titleUrl)"
                      />
                    </div>
                  </div>
                  <div class="box_right">
                    <div class="right">
                      <div class="right_top">
                        {{ item.title }}
                      </div>
                      <div class="right-botttom vottom">
                        <div style="display: flex; align-items: center">
                          <img src="../../assets/yan.png" alt="" />
                          <p>{{ item.pageview }}人观看</p>
                        </div>

                        <div class="button" @click="goHorizoneee(item.id)">
                          去学习
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-pull-refresh>
          </van-list>
        </div>
      </van-tab>
      <van-tab title="心理知识">
        <div class="list">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoadddd"
            :offset="50"
          >
            <van-pull-refresh v-model="isLoading" @refresh="onRefreshs">
              <div
                class="one_list"
                v-for="(item, index) in lovezhishi"
                :key="index"
              >
                <div class="box">
                  <div class="box-left">
                    <div class="left">
                      <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        radius="6px"
                        :src="miXinGetImgUrl(item.titleUrl)"
                      />
                    </div>
                  </div>
                  <div class="box_right">
                    <div class="right">
                      <div class="right_top">
                        {{ item.title }}
                      </div>
                      <div class="right-botttom vottom">
                        <div style="display: flex; align-items: center">
                          <img src="../../assets/yan.png" alt="" />
                          <p>{{ item.pageview }}人观看</p>
                        </div>
                        <div class="button" @click="goHorizoneee(item.id)">
                          去学习
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-pull-refresh>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { lovelist } from "../../api/user";
import { Toast } from "vant";
export default {
  data() {
    return {
      active: 0,
      xinlove: [], // 心灵境界
      chuangfast: [], //心灵之窗
      meimei: [], //心灵美文
      lovezhishi: [],
      loading: false,
      finished: false,
      isLoading: false,
      xinling: {
        articlesType: 3,
        pageNum: 1,
        pageSize: 10,
        status: 0,
        total: 0,
      },
      chuanglist: {
        articlesType: 0,
        pageNum: 1,
        pageSize: 10,
        status: 0,
        total: 0,
      },
      zhishi: {
        articlesType: 2,
        pageNum: 1,
        pageSize: 10,
        status: 0,
        total: 0,
      },

      meiwen: {
        articlesType: 1,
        pageNum: 1,
        pageSize: 10,
        status: 0,
        total: 0,
      },
    };
  },
  created() {
    if (this.$route.query.type) {
      this.active = parseInt(this.$route.query.type);
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    onRefresh() {
      this.xinling.pageNum = 1
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;
        this.onLoad();
      }, 1000);
    },
    onRefreshs() {
      this.chuanglist.pageNum = this.zhishi.pageNum = this.meiwen.pageNum = 1
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;
        this.active === 1 ? this.onLoadd() : this.active === 2 ? this.onLoaddd() : this.active === 3 ? this.onLoadddd() : null
      }, 1000);
    },
    //心理知识
    async getzhishi() {
      const res = await lovelist(this.zhishi);
      if (res.rows == null) {
        this.lovezhishi = [];
        this.finished = true;
      } else {
        this.lovezhishi = this.lovezhishi.concat(res.rows)
        this.zhishi.total = res.total
        this.lovezhishi.length === this.zhishi.total ? this.finished = true : this.zhishi.pageNum++
      }
    },
    onLoadddd() {
      this.loading = false
      this.getzhishi(this.zhishi); // 调用上面方法,请求数据
    },
    //心灵美文
    async getmeiwen() {
      const res = await lovelist(this.meiwen);
      if (res.rows == null) {
        this.meimei = [];
        this.finished = true;
      } else {
        this.meiwen.total = res.total
        this.meimei = this.meimei.concat(res.rows)
        this.meiwen.length === this.meiwen.total ? this.finished = true : this.meiwen.pageNum++
      }
    },
    onLoaddd() {
      this.loading = false
      this.getmeiwen(this.meiwen); // 调用上面方法,请求数据
    },
    //心灵之窗
    async getchuang() {
      this.loading = true
      const res = await lovelist(this.chuanglist);
      if (res.rows == null) {
        this.chuangfast = [];
        this.finished = true;
      } else {
        this.loading = false
        this.chuanglist.total = res.total
        this.chuangfast = this.chuangfast.concat(res.rows)
        this.chuangfast.length === res.total ? this.finished = true : this.chuanglist.pageNum ++
      }
    },
    onLoadd() {
      this.loading = false
      this.getchuang(this.chuanglist)
    },
    //心灵境界
    async getlove() {
      const res = await lovelist(this.xinling);
      if (res.rows == null) {
        this.xinlove = [];
        this.finished = true;
      } else {
        this.xinling.total = res.total
        this.xinlove = this.xinlove.concat(res.rows)
        this.xinlove.length === this.xinling.total ? this.finished = true : this.xinling.pageNum++
      }
    },
    onLoad() {
      this.loading = false
      this.getlove(this.xinling); // 调用上面方法,请求数据
    },
    img() {
      this.miniJump(`/search`)
    },
    goHorizoneee(id) {
      this.miniJump(`/lettres?id=${id}`)
    },
    gohomes() {
      this.$router.go(-1);
    },
    goHorizons(id) {
      window.localStorage.setItem('videoList', JSON.stringify(this.xinlove))
      this.miniJump(`/Horizon?id=${id}`)
    },
    goHorizon(id) {
      window.localStorage.setItem('audioList', JSON.stringify(this.chuangfast))
      this.miniJump(`/soul?id=${id}`)
    },
  },
};
</script>

<style lang="scss" scoped>
.psy-index {
  ::v-deep .van-tabs__content {
    padding: 10px;
    background: #f7f7f7;
  }
  .list {
    width: 100%;
    min-height: calc(100vh - 45px);
  }
  .img {
    position: fixed;
    right: 0;
    top: 0;
    width: 40px;
    height: 44px;
    background: #fff;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 18px;
      height: 18px;
    }
  }
  ::v-deep .van-tabs__wrap {
    padding-right: 40px;
  }

  ::v-deep .van-tabs__line {
    background-color: hsl(211, 100%, 50%);
  }
  .one_list {
    width: 100%;
    height: 100px;
    background: #fefffe;
    border-radius: 8px;
    margin-bottom: 10px;

    .box {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 10px;

        .box_right {
          width: calc(100% - 150px);
          height: 100%;
          .right {
            width: 100%;
            height: 100%;
            position: relative;
            padding: 5px 0;
            .vottom {
              display: flex;
              justify-content: space-between;
              padding: 20px;
              box-sizing: border-box;
            }
            .right-botttom {
              width: 100%;
              display: flex;
              align-items: center;
              padding: 0 0 0 10px;
              position: absolute;
              bottom: 5px;
              .button {
                background: linear-gradient(180deg, #4EA3FF 0%, #007AFF 100%);
                border-radius: 15px;
                opacity: 1;
                color: #ffffff;
                font-size: 0.75rem;
                padding: 6px 15px;
              }

              img {
                width: 12px;
                height: 12px;
              }
              p {
                color: #999;
                font-size: 0.85rem;
              }
            }
            .right_top {
              width: 100%;
              color: #323332;
              font-size: 0.9rem;
              padding: 0 0 0 10px;
              box-sizing: border-box;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
          }
        }
        .box-left {
          width: 150px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .left {
            width: 95%;
            height: 95%;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
  }
}
</style>